import { jsx as _jsx } from "react/jsx-runtime";
import { useRetrievePlayer, useRetrieveUserPlayerPermissions, } from "../ApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import { NotFound } from "../nav/NotFound";
import { useNumericParams } from "../utils/useNumericParams";
import { PlayerPage } from "./PlayerPage";
export const Player = () => {
    const { id } = useNumericParams();
    const { data: userPlayerPermissions, isLoading: userPlayerPermissionsIsLoading, error: userPlayerPermissionsError, } = useRetrieveUserPlayerPermissions({ playerId: id });
    const { canModify = false, canView = false, canViewTeams = false, } = userPlayerPermissions || {};
    const { isLoading, error, data: player, } = useRetrievePlayer({ id, enabled: canView });
    if (userPlayerPermissionsError) {
        return _jsx(ErrorView, { error: userPlayerPermissionsError });
    }
    if (userPlayerPermissionsIsLoading) {
        return _jsx(Loading, {});
    }
    if (!canView) {
        return _jsx(NotFound, {});
    }
    if (error) {
        return _jsx(ErrorView, { error: error });
    }
    if (isLoading) {
        return _jsx(Loading, {});
    }
    if (!player) {
        return _jsx(ErrorView, { error: new Error("Cannot load all data") });
    }
    return (_jsx(PlayerPage, { player: player, canViewTeams: canViewTeams, canModify: canModify }));
};
